import appFeatures from '../app-features'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('login', {
      loggedInUser: 'user'
    }),
    enabledFeatures () {
      return (this.loggedInUser && this.loggedInUser.enabledFeatures) || []
    },
    isGranburyUser () {
      return this.hasFeature(appFeatures.granburyUser)
    },
    hideThings () {
      return {
        backupPrinterField: !this.isGranburyUser,
        disablePricingScheme: !this.isGranburyUser
      }
    },
    hideComponents () {
      return {
        DriverManagementJobs: !this.isGranburyUser,
        EmployeeData: !this.isGranburyUser,
        EmployeeJobsAndWages: !this.isGranburyUser,
        EmployeeSecurity: !this.isGranburyUser,
        EmployeeCertificationsAndRequirements: !this.isGranburyUser,
        LocationOverrides: !this.isGranburyUser
      }
    },
    hidePermissions () {
      return {
        REQUISITION_ITEMS_FOR_PRODUCTION: true,
        WASTE_MENU_ITEMS: true,
        CHANGE_INVENTORY_PURCHASE_PRICES: true,
        CHANGE_INVENTORY_POSTING: true,
        REMOTE_ACCESS_TO_TCC: true
      }
    },
    hideRoutes () {
      return {
        // posDesign: !this.isGranburyUser,
        // kiosk: !this.isGranburyUser,
        groups: !this.isGranburyUser
      }
    }
  },
  methods: {
    hasFeature (feature) {
      return this.enabledFeatures.includes(feature)
    }
  }
}
